import { injectable } from 'tsyringe';
import { OWGameListenerDelegate, OWGameListener } from '../../odk-ts';
import { DelegateProvider } from '../../shared/interfaces/delegate-provider.interface';

// -----------------------------------------------------------------------------
// Testable wrapper for game
@injectable()
export class OWGameListenerWrapper
  implements DelegateProvider<OWGameListenerDelegate>
{
  private readonly listeners: Map<OWGameListenerDelegate, OWGameListener>;

  // ---------------------------------------------------------------------------
  public constructor() {
    this.listeners = new Map<OWGameListenerDelegate, OWGameListener>();
  }

  // ---------------------------------------------------------------------------
  // DelegateProvider
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  addListener(listener: OWGameListenerDelegate) {
    // Make sure we clear callbacks, in case we already have this listener
    this.removeListener(listener);
    this.listeners.set(listener, new OWGameListener(listener, true));
  }

  // ---------------------------------------------------------------------------
  removeListener(listener: OWGameListenerDelegate) {
    const gameListener = this.listeners.get(listener);
    if (!gameListener) {
      return;
    }

    gameListener.stop();
    this.listeners.delete(listener);
  }
}
